export default "__VITE_ASSET__a2855e87__"